import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta10 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-10/utils-consultaSeguimentoPergunta10'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { convertAplicacaoPergunta10 } from './converter-HistoricoMchatPergunta10'

interface HistoricoMChatRfPergunta10Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta10 = (props: Readonly<HistoricoMChatRfPergunta10Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta10(aplicacoes)
  if (converted == null) return null

  const { header, exemplosPassou, exemplosFalhou, perguntaMaiorFrequencia, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta10(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='10'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“Ele...”'
      />
      <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      {perguntaMaiorFrequencia && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta={perguntaMaiorFrequencia.textoPergunta + ':'}
          resposta={'Exemplos ' + (perguntaMaiorFrequencia.stPassou ? 'PASSOU' : 'FALHOU')}
        />
      )}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
